<!-- El marco de SINAY es la ruta padre de todas las pantallas (`components/marco`). La sesion la
     carga `proveerSesion` antes del primer render: sin una de Nomina ya va camino al login
     central, con su aviso, asi que aqui no hay nada que condicionar. -->
<router-outlet />

<!-- Visor global de archivos: UNICA instancia en toda la app (se invoca via FileViewerService).
     El marco no lo trae: solo monta su velo de carga (`<intelishs-overlay-carga>`), que por eso no se
     monta aqui. -->
<intelishs-file-viewer />

<!-- Volver al inicio: UNA vez aqui, nunca por pagina. Sin `target`: desde ui 5.0.8 su default es
     `.shell__contenido`, el <main> del marco, que es quien scrollea (y desde 5.1.3 lo resuelve aunque
     el marco se monte despues, con la primera ruta). -->
<intelishs-back-to-top />
